/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const TableRow = props => {
  const prefix = usePrefix();
  let rowHasAILabel;
  if (props?.children) {
    React__default.Children.toArray(props.children).map(child => {
      if (child.type?.displayName === 'TableSlugRow' || child.type?.displayName === 'TableDecoratorRow') {
        if (child.props.slug || child.props.decorator?.type.displayName === 'AILabel') {
          rowHasAILabel = true;
        }
      }
    });
  }
  // Remove unnecessary props if provided to this component, these are
  // only useful in `TableExpandRow`
  const className = cx(props.className, {
    [`${prefix}--data-table--selected`]: props.isSelected,
    [`${prefix}--data-table--slug-row ${prefix}--data-table--ai-label-row`]: rowHasAILabel
  });
  const {
    ariaLabel,
    'aria-label': ariaLabelAlt,
    'aria-controls': ariaControls,
    onExpand,
    isExpanded,
    isSelected,
    ...cleanProps
  } = props;
  if (className) {
    cleanProps.className = className;
  }
  return /*#__PURE__*/React__default.createElement("tr", cleanProps);
};
TableRow.propTypes = {
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * Specify if the row is selected
   */
  isSelected: PropTypes.bool
};

export { TableRow as default };
